<template>
  <div class="page-wrapper gray steps">
    <Steps
      :steps="steps"
      :current="current"
    />
    <router-view />
  </div>
</template>

<script>
  import Steps from '@/components/steps/StepRockgp';
  import { signup } from '@/staticData/steps';

  export default {
    components: { Steps },
    data() {
      return {
        steps: signup
      };
    },
    computed: {
      current() {
        switch (this.$route.name) {
          case ('signupCreate'):
            return 0;
          case ('signupVerify'):
            return 1;
          default:
            return 2;
        }
      }
    }
  };
</script>